import {SupabaseClient} from '@supabase/supabase-js'
import {ProfileCfg} from './profileTypes'
import {WorkspaceTypes as W} from 'shared/forecast/workspaceTypes'
import {z} from 'zod'
import {Database} from 'utils/db'
import {License} from 'shared/forecast/license'

export namespace WorkspaceData {
  export const createWorkspace = async (
    sb: SupabaseClient<Database>,
    {
      workspace,
      profile,
      user_id,
      license_cfg
    }: {
      workspace: W.Cfg
      profile: Pick<ProfileCfg, 'name' | 'avatar_url' | 'tz'>
      user_id?: string
      license_cfg?: License
    }
  ) =>
    await sb
      .rpc('create_workspace', {cfg: workspace, profile_cfg: profile, user_id, license_cfg})
      .throwOnError()
      .then(r => z.object({workspace_id: z.string(), profile_id: z.string()}).parse(r.data))
}
